import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataLoader from "../../widgets/DataLoader";
import { useBusinessSettings } from "../../contexts/BusinessSettingsContext";
import { getCookie } from "../../utils/utilFunctions";

export default function TokenCookieHandler() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { fetchSettings } = useBusinessSettings();

  useEffect(() => {
    async function handleTokenFromCookie() {
      try {
        console.log("[TokenCookieHandler] Starting token handling from cookie...");

        // Step 1: Get token from cookie set by backend
        const tokenFromCookie = getCookie("access_token");

        if (!tokenFromCookie) {
          console.error("[TokenCookieHandler] ❌ No access_token cookie found");
          navigate("/login");
          return;
        }

        console.log("[TokenCookieHandler] ✅ Token found in cookie:", tokenFromCookie.substring(0, 20) + "...");

        // Step 2: Store token in localStorage as auth_token for consistency
        localStorage.setItem("auth_token", tokenFromCookie);

        // Verify token was stored
        const verifyToken = localStorage.getItem("auth_token");
        console.log("[TokenCookieHandler] ✅ Token stored in localStorage. Verification:", verifyToken ? "SUCCESS" : "FAILED");

        // Step 3: Fetch business settings with the token
        console.log("[TokenCookieHandler] 🔄 Fetching business settings...");
        await fetchSettings();

        console.log("[TokenCookieHandler] ✅ Business settings loaded successfully");

        // Small delay to ensure all state updates are processed
        await new Promise(resolve => setTimeout(resolve, 100));

        console.log("[TokenCookieHandler] ➡️ Navigating to dashboard...");

        // Step 4: Only navigate after settings are loaded
        navigate("/dashboard", { replace: true });
      } catch (error) {
        console.error("[TokenCookieHandler] ❌ Error during token handling from cookie:", error);
        // Clear potentially invalid token
        localStorage.removeItem("auth_token");
        navigate("/login");
      } finally {
        setLoading(false);
      }
    }

    handleTokenFromCookie();
  }, [navigate, fetchSettings]);

  if (loading) {
    return <DataLoader />;
  }

  return null;
}
